import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  searchBoxForm: {
    display: 'flex',
    alignItems: 'center',
  },
  searchBox: {
    marginLeft: theme.spacing(1),
  },
  iconButton: {
    paddingLeft: 8,
    paddingRight: 8,
  },
}));

export default useStyles;
